import { resizeScroll, scrollTo } from './core/ScrollService.js';
import { initModules } from './initModules.js';
import { initToaster } from './features/toaster.js';
import { NavMegamenu } from './features/navMegamenu.js';
import { initSearchbar } from './features/searchbar.js';
import { initDemoMenu } from './features/demoMenu.js';
import { MediaModal } from './features/mediaModal.js';
import { initRedirects } from './features/redirects.js';
import { initInformationPopin } from './features/informationPopin.js';
import { initLotties } from './features/lotties.js';
import { initButtons } from './features/buttons.js';
import { initSubMenuEffect } from './features/subMenuEffect.js';
import { recreateVideoHeader } from './features/videoHeader.js';
import { initPopup } from './features/popup.js';
import { initFormPopup } from './features/formPopup.js';
import { initSommaire } from './features/sommaire.js';
import { initTextareas } from './features/textareas.js';
import { initExternalEmbed } from './features/externalEmbed.js';
import { PAGE_MODULES } from './pages/index.js';
import {
    initFaqCategoriesNav,
    initFooterMobileMenu,
    initHubspotFormScroll,
    initContactPageForms,
} from './pages/globalPageUtils.js';

function bindGlobalPageUtilities() {
    document.querySelectorAll('[data-scrollto]').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const attr = link.getAttribute('data-scrollto');
            const elt = attr ? document.querySelector(attr) : null;
            if (elt) {
                scrollTo(elt);
            }
        });
    });

    if (document.querySelectorAll('[data-clipboard-text]').length) {
        document.querySelectorAll('[data-clipboard-text]').forEach((link) => {
            new ClipboardJS(link);
        });
    }

    if (document.querySelectorAll('.faqCategory_title').length) {
        document.querySelectorAll('.faqCategory_title').forEach((link) => {
            link.addEventListener('click', () => {
                if (!link.getAttribute('data-category')) return;

                window.location.hash = '#' + link.getAttribute('data-category');

                const tooltip = link.querySelector('.tooltip');
                const tooltipDefault = tooltip.getAttribute('data-state-default');
                const tooltipClicked = tooltip.getAttribute('data-state-clicked');

                tooltip.innerHTML = tooltipClicked;
                setTimeout(() => {
                    tooltip.innerHTML = tooltipDefault;
                }, 2000);
            });
        });
    }
}

export function runPage() {
    initToaster();

    if (document.getElementById('nav-megamenu')) {
        new NavMegamenu().init();
    }

    initSearchbar();
    initDemoMenu();
    initModules();
    new MediaModal().init();
    initRedirects();
    initInformationPopin();
    initLotties();
    initButtons();
    initSubMenuEffect();
    recreateVideoHeader();
    initPopup();
    initFormPopup();
    initSommaire();

    setTimeout(() => {
        initTextareas();
        resizeScroll();
    }, 300);

    bindGlobalPageUtilities();

    PAGE_MODULES.filter((Page) => Page.matches()).forEach((Page) => new Page().init());

    initFaqCategoriesNav();
    initFooterMobileMenu();
    initHubspotFormScroll();
    initContactPageForms();
    initExternalEmbed();
}
